import React from "react";
import { CloseButton } from "../components/closeButton";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";

const RegisterManifestFieldSet = ({ idx, register, setValue }: { idx: number; register: any; setValue: any }) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileNameWithoutExtension = file.name.split(".").slice(0, -1).join(".");
      setValue(`${idx}.name`, fileNameWithoutExtension);
    }
  };

  return (
    <>
      <div className="flex flex-row">
        <label className="block">
          <span className="text-1xl block text-gray-800">Manifest Name</span>
          <input
            {...register(`${idx}.name`, { required: true })}
            type="text"
            className="form-input mt-1 block w-full rounded text-gray-800"
          />
        </label>
      </div>

      <label className="mt-4 block">
        <span className="text-1xl text-grey-800 block">Upload manifest</span>
        <input
          type="file"
          className="form-input mt-1 w-full rounded border bg-gray-100 bg-clip-padding text-gray-800"
          {...register(`${idx}.manifest`, {
            required: true,
          })}
          onChange={handleFileChange}
        />
      </label>
    </>
  );
};

export default function RegisterManifestForm({ onSubmit, handleClose }: { onSubmit: (data: any) => void; handleClose: () => void }) {
  const methods = useForm({
    defaultValues: {
      manifests: [
        {
          name: "Enter manifest name",
          manifest: null,
        },
      ],
    },
  });

  const {
    handleSubmit,
    register,
    control,
    setValue,
    formState: { errors },
  } = methods;

  const { fields: manifestFields } = useFieldArray({
    control,
    name: "manifests",
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CloseButton
          className={"absolute top-2 right-2"}
          handleClick={handleClose}
        />
        {/* TODO: Error handling */}
        <div className="flex flex-wrap gap-4">
          {manifestFields.map((field, i) => (
            <RegisterManifestFieldSet
              key={field.id}
              idx={i}
              register={register}
              setValue={setValue}
            />
          ))}
        </div>
        <button
          className="ox-button mt-4 w-full"
          onClick={handleSubmit(onSubmit)}
        >
          <span>Submit</span>
        </button>
      </form>
    </FormProvider>
  );
}
